import { statusRequiresInterviewDate } from './candidateStatus';

export const STATUS_UPDATE_SUCCESS_MESSAGE = 'Status Updated Successfully ✓';

export function validateStatusUpdate({
  selectedStatus,
  statusRemark,
  statusInterviewDate,
}) {
  const missing = [];

  if (!selectedStatus || !String(selectedStatus).trim()) {
    missing.push('Status');
  }

  if (!String(statusRemark || '').trim()) {
    missing.push('Remark');
  }

  if (
    selectedStatus
    && statusRequiresInterviewDate(selectedStatus)
    && !statusInterviewDate
  ) {
    missing.push('Interview Date');
  }

  if (missing.length === 0) {
    return { ok: true };
  }

  if (missing.length === 1) {
    if (missing[0] === 'Status') {
      return { ok: false, message: 'Please select a status.' };
    }
    if (missing[0] === 'Remark') {
      return { ok: false, message: 'Remark is required when updating status.' };
    }
    if (missing[0] === 'Interview Date') {
      return { ok: false, message: 'Interview Date is required.' };
    }
  }

  return {
    ok: false,
    message: `Please complete the following required fields:\n• ${missing.join('\n• ')}`,
  };
}
